
export const makerCheckerRolePermission = {
	'Super Admin': ['MAKER', 'CHECKER', 'NONE'],
	'Admin User': ['NONE'],
	'Operation User': ['MAKER', 'CHECKER', 'NONE'],
	'Tech User': ['CHECKER', 'NONE'],
	'Etr User': ['MAKER', 'CHECKER', 'NONE']
}
